import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import validator from "validator";

// Custom
import { LoadingButton, StyledTextField } from "../general";
import Colors from "../../constants/Colors";
import StyledParagraph from "../general/StyledParagraph";

const CodeInput = ({
  validateCode,
  loading,
  codeErrorMsg,
  setCodeErrorMsg,
  t,
}) => {
  const [enteredCode, setEnteredCode] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validator.isEmpty(enteredCode)) {
      setCodeErrorMsg(t("auth.noCode"));
      return true;
    } else {
      validateCode(enteredCode);
    }
  };

  return (
    <div style={{ width: "100%", marginBottom: 12 }}>
      <div style={{ padding: 10 }}>
        <StyledParagraph
          style={{
            marginBottom: 16,
            marginTop: 0,
          }}
        >
          {t("auth.codeHelpText")}
        </StyledParagraph>
        <StyledParagraph
          style={{
            color: Colors.grey,
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          {t("auth.codeTip")}
        </StyledParagraph>

        <form style={{ width: "100%" }} onSubmit={handleSubmit}>
          <StyledTextField
            name="code"
            onChange={(e) => setEnteredCode(e.target.value)}
            error={codeErrorMsg !== ""}
            errorText={codeErrorMsg}
            textFieldProps={{
              placeholder: "gen-redolently-minder-pate-unthrifty-loafer",
            }}
          />
          <LoadingButton text={t("auth.logIn")} loading={loading} />
        </form>
      </div>
    </div>
  );
};

export default withTranslation("common")(CodeInput);
